import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=2d125013&"
import script from "./RouteList.vue?vue&type=script&lang=js&"
export * from "./RouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports